module.exports = __webpack_public_path__ + "03_medium_gold.b645ca8d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/mom/layer5/03_medium_gold.png
// module id = 3t3z
// module chunks = 0